import { render, staticRenderFns } from "./NewMark.vue?vue&type=template&id=68db719b&scoped=true&"
import script from "./NewMark.vue?vue&type=script&lang=js&"
export * from "./NewMark.vue?vue&type=script&lang=js&"
import style0 from "./NewMark.vue?vue&type=style&index=0&id=68db719b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68db719b",
  null
  
)

export default component.exports